/* global axios */
import ApiClient from './ApiClient';

class HistoryAPI extends ApiClient {
  constructor() {
    super('historico_operacional', { accountScoped: true });
  }

  show(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default new HistoryAPI();
